import React from 'react'

const getMeta = (item, years) => {
  let sum = 0
  if (!years.length) sum = item.meta1 + item.meta2 + item.meta3 + item.meta4;
  else
    sum = years.reduce((pre, cur) => {
      if (cur === '2020') return pre + item.meta1
      if (cur === '2021') return pre + item.meta2
      if (cur === '2022') return pre + item.meta3
      if (cur === '2023') return pre + item.meta4
      return pre
    }, 0);
  if (item.unidad === 'Porcentaje') return Math.round(sum * 100) + '%'
  return parseInt(sum * 100) / 100
}

const TablePisccReportes = (props) => {
  return (
    <table className="table-results-piscc">
      <thead>
        <tr>
          <th>Línea estratégica</th>
          <th>Indicador</th>
          <th>Meta</th>
          <th>Peso</th>
          <th>Reporte</th>
        </tr>
      </thead>
      <tbody>
        {
          props.content.map(item => (
            <tr key={'row-table-hg ash-' + item.id}>
              <td>{item.linea}</td>
              <td>{item.indicador}</td>
              <td>{getMeta(item, props.years)}</td>
              <td>{Math.round(100 * item['refPisccNivelAlcance.nivel']) / 100}</td>
              <td>
                <i onClick={() => props.select(item.id)} className='fas fa-check-square piscc-icon-button' title='Seleccionar' style={item.active ? { color: 'green' } : { color: 'gray' }}></i>
                <i onClick={() => props.watch(item.id)} className='far fa-eye piscc-icon-button' title='Ver reporte' style={{ color: 'orange' }}></i>
                <i onClick={() => props.add(item.id)} className='fas fa-plus piscc-icon-button primary-color' title='Agregar reporte'></i>
              </td>
            </tr>
          ))
        }
      </tbody>
    </table>
  )
}

export default TablePisccReportes